import React from 'react';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';

const MonthlyTrendsChart = ({ data }) => {
    const chartData = {
        labels: data.map(item => item.month),
        datasets: [
            {
                label: 'Disbursed Amount',
                data: data.map(item => item.disbursedAmount),
                borderColor: '#42A5F5',
                backgroundColor: 'rgba(66, 165, 245, 0.2)',
                fill: true,
                tension: 0.4
            },
            {
                label: 'Collections',
                data: data.map(item => item.collections),
                borderColor: '#66BB6A',
                backgroundColor: 'rgba(102, 187, 106, 0.2)',
                fill: true,
                tension: 0.4
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: (value) => '₹' + value.toLocaleString()
                }
            }
        }
    };

    return (
        <Card className="chart-card">
            <div className="chart-header">
                <h3>Monthly Trends</h3>
                <div className="chart-subtitle">Disbursements vs Collections</div>
            </div>
            <div className="chart-container">
                <Chart type="line" data={chartData} options={options} />
            </div>
        </Card>
    );
};

export default MonthlyTrendsChart;
